import { memo } from 'react';

const BusinessDetailAbout = memo(({ about }) => (
  <div className="flex w-full flex-col gap-0.75 desktop:gap-1">
    <p className="desktop:text-[16px] text-sm font-medium leading-4.5 desktop:leading-6 text-merchant-text-secondary">
      About
    </p>
    <p className="desktop:text-[16px] text-sm font-medium leading-4.5 desktop:leading-6 text-merchant-text-primary">
      {about}
    </p>
  </div>
));

BusinessDetailAbout.displayName = 'BusinessDetailAbout';

export default BusinessDetailAbout;
